import type { IconData } from '@stacksjs/iconify-core'

export const borderInner: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M240 272v200h32V272h200v-32H272V40h-32v200H40v32zm200 168h32v32h-32zm-133.818 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-267.636 0h33.455v32h-33.455zM40 440h32v32H40zm0-133.817h32v33.454H40zm0 66.909h32v33.454H40zm0-200.728h32v33.454H40zm0-66.909h32v33.454H40zM40 40h32v32H40zm266.182 0h33.455v32h-33.455zm-133.818 0h33.455v32h-33.455zm200.727 0h33.455v32h-33.455zm-267.636 0h33.455v32h-33.455zM440 40h32v32h-32zm0 333.091h32v33.454h-32zm0-66.909h32v33.454h-32zm0-200.728h32v33.454h-32zm0 66.909h32v33.454h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default borderInner
